/* Phonelyne theme — global interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var header = toggle.closest('.site-header');
      if (header) {
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  // Keyboard-accessible header dropdowns
  document.querySelectorAll('.has-dropdown__toggle').forEach(function (btn) {
    var parent = btn.closest('.has-dropdown');
    btn.addEventListener('click', function () {
      var expanded = parent.getAttribute('aria-expanded') === 'true';
      parent.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (!parent.contains(e.target)) parent.setAttribute('aria-expanded', 'false');
    });
  });

  // Destination search — filter destination cards live, scoped to each
  // input's own section so multiple search boxes never cross-filter.
  // Sections that manage their own search/region logic opt out via
  // [data-search-managed] (e.g. the coverage map).
  document.querySelectorAll('[data-destination-search]').forEach(function (input) {
    if (input.closest('[data-search-managed]')) return;
    var scope = input.closest('section') || document;
    input.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      scope.querySelectorAll('[data-destination-name]').forEach(function (card) {
        var name = (card.getAttribute('data-destination-name') || '').toLowerCase();
        card.style.display = !q || name.indexOf(q) !== -1 ? '' : 'none';
      });
    });
  });

  // Sticky header — add shadow / solid background once scrolled
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Reveal-on-scroll animations (respects reduced-motion)
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealables = document.querySelectorAll('.reveal, .section > .page-width, .feature-band__inner > .page-width');
  if (reduce || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealables.forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }

  // Live cart count refresh after AJAX add-to-cart events
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('.site-nav__cart-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });
})();
